import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withLastLocation } from 'react-router-last-location';
import classnames from 'classnames';
import cogoToast from 'cogo-toast';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import _ from 'lodash';

import ScrollToTop from '../../Components/General/ScrollToTop';
import BlogPostElements from '../../Components/Blog/BlogPostElements';

import { addEvent } from '../../APIClient/events';
import { getBlogPost, createBlogPostElement, editBlogPostElement, deleteBlogPostElement } from '../../Actions/BlogActions';
import { isAdmin } from '../../Helpers/user_helpers';
import { getAmpScriptTagForBlogPost } from '../../Helpers/seo_helpers';

import './BlogPost.scss';

class BlogPost extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    blog: PropTypes.object.isRequired,
    getBlogPost: PropTypes.func.isRequired,
    editBlogPostElement: PropTypes.func.isRequired,
    createBlogPostElement: PropTypes.func.isRequired,
    deleteBlogPostElement: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { match, user } = this.props;
    const postTitle = match.params.title;
    this.props.getBlogPost(postTitle).then(resp => {
      resp.error && cogoToast.error(resp.error);
      if (!isAdmin(user)) {
        addEvent('BLOG_POST_VIEW', {
          title: _.get(resp, 'post.title'),
          subtitle: _.get(resp, 'post.subtitle'),
          postId: _.get(resp, 'post.id')
        });
      }
    });
  }

  state = {
    isEditing: isAdmin(this.props.user) && !_.get(this.props, 'blog.visiblePost.elements.length')
  };

  isFetching = () => this.props.match.params.title !== _.get(this.props, 'blog.visiblePost.titleStub');

  toggleEditingMode = () => this.setState({ isEditing: !this.state.isEditing });

  render() {
    const { blog, lastLocation } = this.props;
    const { isEditing } = this.state;
    const { visiblePost } = blog || {};
    const { title, subtitle, elements, coverImage } = visiblePost || {};
    const fromHome = lastLocation?.pathname?.includes('/home');
    const fromLatest = lastLocation?.pathname?.includes('/latest');
    const isFetching = this.isFetching();

    if (!isFetching && !visiblePost) return null;
    const shareImage =
      coverImage || _.filter(_.map(elements, el => _.get(el, 'image') || _.get(el, 'pin.image') || _.get(el, 'collection.pins.0.image')))[0];
    return (
      <div
        className={classnames('blog-post-outer-container', {
          fetching: isFetching
        })}
      >
        <MetaTags>
          <title>{isFetching ? '' : title}</title>
          <meta property='og:title' content={isFetching ? '' : title} />
          <meta property='description' content={isFetching ? '' : subtitle} />
          <meta property='og:description' content={isFetching ? '' : subtitle} />
          {shareImage && <meta property='og:image' content={isFetching ? '' : shareImage} />}
          {visiblePost && getAmpScriptTagForBlogPost(visiblePost)}
        </MetaTags>
        <ScrollToTop from={['/blog', '/talent', '/home', '/latest']} />
        <div className='top-row'>
          <div onClick={() => (fromHome || fromLatest ? this.props.history.goBack() : this.props.history.push('/blog'))} className='back-link'>
            <FontAwesomeIcon icon={faArrowLeft} className='back' />
            Back {fromLatest ? '' : fromHome ? 'Home' : 'To Blog'}
          </div>
        </div>
        <div itemScope className='blog-post-header-container'>
          <h1 itemProp='name'>{isFetching ? '    ' : title || '    '}</h1>
          <h2 itemProp='description'>{isFetching ? '    ' : subtitle || '    '}</h2>
        </div>
        {!visiblePost || isFetching ? null : isEditing ? (
          <div className='blog-post-edit-container'>
            <BlogPostElements
              isEditing
              post={visiblePost}
              user={this.props.user}
              createBlogPostElement={this.props.createBlogPostElement}
              editBlogPostElement={this.props.editBlogPostElement}
              deleteBlogPostElement={this.props.deleteBlogPostElement}
              toggleEditingMode={this.toggleEditingMode}
            />
          </div>
        ) : (
          <div className='blog-post-container'>
            <BlogPostElements
              post={visiblePost}
              user={this.props.user}
              editBlogPostElement={this.props.editBlogPostElement}
              toggleEditingMode={this.toggleEditingMode}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { user, blog } = state;
  return { user, blog };
};

export default connect(mapStateToProps, {
  getBlogPost,
  createBlogPostElement,
  editBlogPostElement,
  deleteBlogPostElement
})(withLastLocation(withRouter(BlogPost)));
